import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PresentingComplaintForm() {
    return (
        <PatientFormTemplate formTitle="Your Current Concerns" />
    );
}